import { render, staticRenderFns } from "./ShippingFBA.vue?vue&type=template&id=764a5f0b&scoped=true"
import script from "./ShippingFBA.vue?vue&type=script&lang=js"
export * from "./ShippingFBA.vue?vue&type=script&lang=js"
import style0 from "./ShippingFBA.vue?vue&type=style&index=0&id=764a5f0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764a5f0b",
  null
  
)

export default component.exports